export const engagementLandingPageStatsLandingPageBsonId =
  "/engagement/landing_pages/:app_group_id/landing_page_stats/:landing_page_id";
